export function validEmailAddress(value: string): boolean {
    const email = value.trim();
    return email.length <= 254 && /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(email) && !/[\r\n]/.test(value);
}

export function defaultCompletionEmail(user?: { email?: string; nickname?: string; name?: string }): string {
    if (user?.email?.trim()) return user.email.trim();
    return [user?.nickname, user?.name].find(value => value && validEmailAddress(value))?.trim() ?? '';
}
